import { render, staticRenderFns } from "./GraficoPrevisaoFaturamento.vue?vue&type=template&id=bfeb4af8&scoped=true"
import script from "./GraficoPrevisaoFaturamento.vue?vue&type=script&lang=ts"
export * from "./GraficoPrevisaoFaturamento.vue?vue&type=script&lang=ts"
import style0 from "./GraficoPrevisaoFaturamento.vue?vue&type=style&index=0&id=bfeb4af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeb4af8",
  null
  
)

export default component.exports